// Enumerate views
const viewContexts = require.context('.', false /* Without subdirectories */, /[\w\d]+\.vue/)

let views = Object.create(null)
viewContexts.keys().forEach((viewFilename) => {
		
	// Get module and name
	const viewModule = viewContexts(viewFilename)
	const viewName = viewFilename.split('/').pop().replace('.vue', '')

	// Add to views
	views[viewName] = viewModule.default || viewModule
})

export default views